/* eslint-disable @typescript-eslint/no-empty-function */
import { reactive } from 'vue';
import { Props } from '../models/component';
import { delay } from '../utils/util';

interface State {
  display?: boolean,
  text: string,
  textAction?: string | undefined,
  color?: string | undefined,
  textColor?: string | undefined,
  textActionColor?: string | undefined,
  props?: Props,
}

interface Methods {
  // show(obj: State): Promise<void>,
  show(obj: State): Promise<void> | void,
  hide(): void,
}

interface Snackbar extends State, Methods {}

const createState = () => {
  const state = reactive<Snackbar>({
    display: false,
    text: '',
    textAction: '',
    color: 'warning',
    textColor: 'text-white',
    textActionColor: 'text-grey-darken-4',
    async show() {
      console.log('show');
    },
    hide() {
      console.log('hide');
    },
  });

  state.show = async (obj: State) => {
    const { text, textAction, color, textColor, textActionColor, props } = obj;
    state.text = text;
    state.textAction = textAction;
    state.color = color;
    state.textColor = textColor;
    state.textActionColor = textActionColor;
    state.props = { ...(props ?? {}), timeout: props?.timeout ?? 5000 };
    state.display = true;
    await delay(state.props.timeout);
  };

  state.hide = () => {
    state.display = false;
  };

  return state;
};

const state = createState();

export default state;

export {
  State,
  Snackbar,
  state,
  createState,
};
